module.exports = new __parcel__URL__("cleaning_facility.f198f6b8.jpg").toString();